import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-ivory" data-id="element-150" data-mp="35352e4xiu0lp">
      <Header data-id="element-151" data-mp="3a1ewec7iev5q" />
      <main className="flex-1" data-id="element-152" data-mp="3a0wqsoyyj4l5">
        <Outlet data-id="element-153" data-mp="3a4avw4z09rwa" />
      </main>
      <Footer data-id="element-154" data-mp="3f11b6q2zkjgn" />
    </div>;
}